import api from "../../../services/api";

export function productHelper() {
    async function getProduct(product_id: string, token: string) {
        try {
            return await api
                .get(`api/product/${product_id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
                .then((response) => {
                    const productData = response.data.data[0];
                    return productData;
                })
                .catch((err) => {
                    console.log(err);
                    return null
                });
        } catch (error) {
            console.log("Erro ao buscar produto:", error);
            return null
        }
    }

    async function getProductClassifications(classificationId: string, token: string): Promise<string | null> {
        return await api
            .get(
                `api/classification/${classificationId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                },
            )
            .then(async (responseSubcategory) => {
                return responseSubcategory.data.data[0].name;
            })
            .catch((err) => {
                console.log(err);
                return null;
            });
    }

    return {
        getProduct,
        getProductClassifications
    }

}